import React, { useState } from 'react';

export interface LazyDetailsProps {
  className?: string;
  summary: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  bodyClassName?: string;
}

/**
 * Collapsible section that mounts heavy children only while open.
 */
const LazyDetails: React.FC<LazyDetailsProps> = ({
  className,
  summary,
  children,
  defaultOpen = false,
  bodyClassName = 'eval-run-result__details-body',
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <details
      className={className}
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary>{summary}</summary>
      {open ? <div className={bodyClassName}>{children}</div> : null}
    </details>
  );
};

export default LazyDetails;
